<template lang="pug">
    .sections
        v-dialog(
            v-model="removeDialog"
            persistent
            width="400px"
        )
            v-card
                v-card-title
                    span.title.mx-auto {{$vuetify.lang.t('$vuetify.pages.Sections.deleting')}}
                v-card-text.pb-1.text-center
                    span {{$vuetify.lang.t('$vuetify.pages.Sections.areYouSureToDelete')}}
                v-card-actions.d-flex.justify-center
                    v-btn(@click="closeRemoveDialog" text) {{$vuetify.lang.t('$vuetify.buttons.cancel')}}
                    v-btn.white--text(@click="remove" color="red") {{$vuetify.lang.t('$vuetify.buttons.remove')}}
        v-dialog(
            v-model="editDialog"
            v-if="editDialog"
            width="800px"
            persistent
        )
            v-card.px-3
                v-card-title.mb-7
                    span.headline.mx-auto {{ $vuetify.lang.t(`$vuetify.pages.Sections.table.${isEditMode ? 'edit' : 'create'}`) }}
                v-card-text
                    v-locale(controlled v-model="editingLocale")
                    v-row.mb-4.mt-3
                        v-col.py-0(cols="12" sm="4")
                            v-text-field(
                                v-model="section[localizeField('name', editingLocale)]"
                                :label="$vuetify.lang.t('$vuetify.pages.Sections.table.name') + ' *'"
                                outlined
                                counter="255"
                                maxLength="255"
                            )
                        v-col.py-0(cols="12" sm="4")
                            v-select(
                                :items="statuses"
                                :disabled="!isEditMode"
                                :label="$vuetify.lang.t('$vuetify.pages.Sections.table.status') + ' *'"
                                item-value="key"
                                item-text="text"
                                v-model="section.status"
                                color="secondary"
                                hide-details
                                outlined
                            )
                        v-col.py-0(cols="12" sm="4" v-if="roleName !== 'admin-establishment'")
                            v-text-field(
                                  v-model="section.margin"
                                  :label="$vuetify.lang.t('$vuetify.pages.Establishments.table.margin') + ' *'"
                                  :error-messages="getValidateMessage('Establishment', 'establishment.margin', 'margin')"
                                  outlined
                                  type="number"
                                  append-icon="percent"
                            )
                    v-row
                        v-col.py-0(cols="12" sm="4")
                            v-select(
                                :disabled="!!userBrandId"
                                :label="$vuetify.lang.t(`$vuetify.pages.Users.table.brandId`) + ' *'"
                                :items="brands"
                                v-model="section.brandId"
                                item-text="title"
                                item-value="id"
                                hide-details
                                clearable
                                outlined
                            )
                            template(v-slot:selection="{ item }")
                                span {{ item.id | brand }}
                            template(v-slot:item="{ item }")
                                span {{ item.id | brand }}
                        v-col.py-0(cols="12" sm="4")
                            v-select(
                              :disabled="!!userEstablishmentId || !section.brandId"
                              :label="$vuetify.lang.t(`$vuetify.pages.Users.table.establishmentId`) + ' *'"
                              :items="section.brandId ? (userEstablishmentId ? [establishments.find(i => +i.id === +userEstablishmentId)] : establishments.filter(i => +i.brandId === +section.brandId)) : establishments"
                              v-model="section.establishmentId"
                              :item-text="localizeField('name', $vuetify.lang.current)"
                              item-value="id"
                              hide-details
                              clearable
                              outlined
                            )
                        v-col.py-0(cols="12" sm="4")
                            v-select(
                              :disabled="!section.establishmentId"
                              :label="$vuetify.lang.t(`$vuetify.pages.Sections.table.establishmentAddress`)"
                              :items="establishmentAddresses"
                              v-model="section.establishmentAddressId"
                              item-value="id"
                              clearable
                              outlined
                            )
                                template(v-slot:selection="{ item }")
                                    span {{item.place | place}}
                                template(v-slot:item="{ item }")
                                    span {{item.place | place}}
                    v-text-field.mt-10(
                      v-model="section[localizeField('description', editingLocale)]"
                      :label="$vuetify.lang.t('$vuetify.pages.Sections.table.description')"
                      outlined
                      hide-details
                      counter="255"
                      maxLength="255"
                    )
                v-card-actions.d-flex.justify-end.buttons
                    v-btn.white--text(@click="closeEditDialog" color="red") {{$vuetify.lang.t('$vuetify.buttons.cancel')}}
                    v-btn(
                        :loading="requestProcessing"
                        :disabled="$v.section.$invalid || !isSaveBtnEnabled"
                        @click="saveSection"
                        color="secondary"
                    ) {{$vuetify.lang.t(`$vuetify.buttons.${isEditMode ? 'save' : 'create'}`)}}
        .v-card.elevation-5.pa-4.mb-5
            v-card-text.d-flex.justify-center
                span.headline {{ $vuetify.lang.t('$vuetify.filters') }}
            v-card-text.px-0
                v-row.d-flex.justify-center
                    v-col.py-0(cols="12" sm="4")
                        v-text-field(
                            :label="$vuetify.lang.t('$vuetify.pages.Brands.filters.query')"
                            v-model="filters.query"
                            :counter="255"
                            maxLength="255"
                            outlined
                        )
                    v-col.py-0(cols="12" sm="4")
                        v-select(
                            :disabled="!!userBrandId"
                            :label="$vuetify.lang.t(`$vuetify.pages.Users.table.brandId`)"
                            :items="brands"
                            v-model="filters.brandId"
                            item-text="title"
                            item-value="id"
                            hide-details
                            clearable
                            outlined
                        )
                            template(v-slot:selection="{ item }")
                                span {{ item.id | brand }}
                            template(v-slot:item="{ item }")
                                span {{ item.id | brand }}
                    v-col.py-0(cols="12" sm="4")
                        v-select(
                          :disabled="!!userEstablishmentId"
                          :label="$vuetify.lang.t(`$vuetify.pages.Users.table.establishmentId`)"
                          :items="filters.brandId ? establishments.filter(i => i.brandId === filters.brandId) : establishments"
                          v-model="filters.establishmentId"
                          item-text="title"
                          item-value="id"
                          hide-details
                          clearable
                          outlined
                        )
                            template(v-slot:selection="{ item }")
                                span {{ item[localizeField('name', $vuetify.lang.current)] }}
                            template(v-slot:item="{ item }")
                                span {{ item[localizeField('name', $vuetify.lang.current)] }}
                .d-flex.full-width.justify-end
                    v-btn(
                      @click="loadItems()"
                      color="secondary"
                    ) {{$vuetify.lang.t('$vuetify.buttons.search')}}
        .table-wrapper
            v-data-table.elevation-5.data-table(
                :headers="headers"
                :items="items"
                :items-per-page="200"
                :mobile-breakpoint="300"
                hide-default-footer
            )
                template(v-slot:item.position="{ item }")
                    span {{ item.order }}
                template(v-slot:item.establishment="{ item }")
                    span {{ item.establishment[localizeField('name', $vuetify.lang.current)] }}
                template(v-slot:item.establishmentAddress="{ item }")
                    span {{ item.establishmentAddress && item.establishmentAddress.place ? $options.filters.place(item.establishmentAddress.place) : '' }}
                template(v-slot:item.image="{ item }")
                    span {{ item.imgUrl | ellipsisInfo }}
                template(v-slot:item.margin="{ item }")
                    span {{ item.margin + '%' }}
                template(v-slot:item.status="{ item }")
                    span {{ $vuetify.lang.t(`$vuetify.pages.Sections.table.statuses.${item.status}`) }}
                template(v-slot:item.createdAt="{ item }")
                    span.no-wrap {{ item.createdAt | timeAndDate }}
                template(v-slot:item.updatedAt="{ item }")
                    span.no-wrap {{item.updatedAt | timeAndDate }}
                template(v-slot:item.order="{ item }")
                    v-btn(@click="lowerSection(item.id)" color="black" icon :disabled="item.order >= pagination.count")
                        v-icon mdi-chevron-down
                    v-btn(@click="raiseSection(item.id)" color="black" icon :disabled="item.order <= 1")
                        v-icon mdi-chevron-up
                template(v-slot:item.actions="{ item }")
                    v-btn(@click="openEditDialog(item)" icon)
                        v-icon edit
                    v-btn(@click="openRemoveDialog(item.id)" color="red" icon :disabled="item.productCount !== '0'")
                        v-icon delete
        v-pagination(
            v-if="pagination.totalPages > 1"
            :disabled="requestProcessing"
            :value="pagination.page"
            :length="pagination.totalPages"
            @input="onPageChange($event)"
            :total-visible="8"
            color="black"
        )
        v-btn.mx-2.add-btn(
            @click="openEditDialog"
            fab dark
        )
            v-icon(dark) mdi-plus
</template>

<script>
import request from '@/utils/request';
import { getFormData } from '@/utils/helpers';

import { mapState, mapGetters, mapActions } from 'vuex';
import {decimal, maxValue as max, minValue as min, required} from "vuelidate/lib/validators";
import validate from '@/mixins/validate';
import {validationMixin} from "vuelidate";
import {localizeField, multilingualFieldKeys, multilingualFields} from "@/helpers/locales";

const SectionStatuses = {
    DRAFT: 'draft',
    PUBLISH: 'publish'
};

const sectionInitialState = () => ({
  ...multilingualFields(['name']),
    margin: 0,
    status: SectionStatuses.DRAFT,
    brandId: null,
    establishmentId: null,
    establishmentAddressId: null
});

export default {
    name: 'Sections',
    mixins: [validate, validationMixin],
    data: () => ({
        isLoading: false,
        editDialog: false,
        editingLocale: 'uk',
        removeDialog: false,
        idToRemove: null,
        section: sectionInitialState(),
        requestProcessing: false,
        filters: {
            brandId: null,
            query: null
        },

        establishmentAddresses: [],
    }),
    validations: {
        section: {
            brandId: {
              required
            },
            establishmentId: {
              required
            },
            margin: {
              min: min(0),
              max: max(100),
              decimal
            },
        }
    },
    setup() {
      return {
        localizeField
      };
    },
    computed: {
        ...mapGetters(['roleName', 'userBrandId', 'userEstablishmentId', 'userEstablishmentAddressId']),
        ...mapState({
            items: state => state.deliverySections.items,
            pagination: state => state.deliverySections.pagination,
            brands: state => state.data.brands,
            establishments: state => state.data.establishments
        }),
        headers() {
            const titles = ['establishment', 'establishmentAddress', ...multilingualFieldKeys(['name', 'description']), ...(this.roleName === 'admin-establishment' ? [] : ['margin']), 'status', 'createdAt', 'updatedAt'];

            if (this.filters.establishmentId || this.userEstablishmentId) {
                titles.unshift('position');
                titles.push('order');
            }

            // if (['admin', 'admin-delivery', 'admin-establishment']) { //TODO: find out what it does
                titles.push('actions');
            // }
            return titles.map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Sections.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        statuses() {
          return Object.values(SectionStatuses).map(status => ({
              key: status,
              text: this.$vuetify.lang.t(`$vuetify.pages.Sections.table.statuses.${status}`)
          }));
        },
        isEditMode() {
            return this.editDialog && this.section.id !== undefined;
        },
        isSaveBtnEnabled() {
            return multilingualFieldKeys(['name']).some((field) => !!this.section[field]);
        },
    },
    watch: {
      async 'section.establishmentId'(currentValue, prevValue) {
        if (currentValue) {
          if (prevValue && currentValue !== prevValue) {
            this.section.establishmentAddressId = null;
          }

          await request({ method: 'get', url: `/delivery/establishment/${currentValue}/addresses` })
              .then(res => {
                if (res.data) {
                  this.establishmentAddresses = this.userEstablishmentAddressId ? [res.data.find(i => i.id === this.userEstablishmentAddressId)] : res.data;

                  // if (this.userEstablishmentAddressId || (!this.section.establishmentAddressId && this.establishmentAddresses.length === 1)) {
                  //   this.section.establishmentAddressId = this.establishmentAddresses[0].id;
                  // }
                }
              }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                  this.$store.dispatch('alert/addMessage', {
                    message: error.response.data.error
                  }, { root: true });
                }
              });
        } else {
          this.establishmentAddresses = [];
          this.section.establishmentAddressId = null;
        }
      }
    },
    async created() {
        await this.getBrands();
        await this.getEstablishments();
        if (this.userBrandId) {
            this.filters.brandId = this.userBrandId;
            this.filters.establishmentId = this.userEstablishmentId;

            this.section.brandId = this.userBrandId;
            this.section.establishmentId = this.userEstablishmentId;
        }
        // this.loadItems(this.pagination.page);
    },
    methods: {
        ...mapActions({
            getItems: 'deliverySections/getItems',
            lowerSectionRequest: 'deliverySections/lowerSection',
            raiseSectionRequest: 'deliverySections/raiseSection',
            getBrands: 'data/getBrands',
            getEstablishments: 'data/getEstablishments'
        }),
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.getItems(Object.assign({}, {
                page,
                ...this.filters
            })).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },
        lowerSection(id) {
          if (this.requestProcessing) return;

          this.requestProcessing = true;

          this.lowerSectionRequest(id).then(() => {
            this.$nextTick(() => {
              this.requestProcessing = false;
              this.loadItems(this.pagination.page);
            });
          });
        },
        raiseSection(id) {
          if (this.requestProcessing) return;

          this.requestProcessing = true;

          this.raiseSectionRequest(id).then(() => {
            this.$nextTick(() => {
              this.requestProcessing = false;
              this.loadItems(this.pagination.page);
            });
          });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        },
        openEditDialog(item) {
            this.section = { ...this.section, ...(item || {}) };
            this.editDialog = true;
        },
        async saveSection() {
            if (this.requestProcessing) {
                return;
            }

            if (this.$v.section.$invalid) {
              this.$v.$touch();
              this.$nextTick(() => this.focusFirstErrorInput());
              return;
            }

            const { id } = this.section;

            const method = id ? 'put' : 'post';
            const url = id ? `/delivery/section/${id}` : '/delivery/section';

            const ignoredKeys = ['createdAt', 'updatedAt'];
            const preparedData = Object.reject(this.section, ignoredKeys);

            preparedData.margin = parseFloat(preparedData.margin) / 100;

            const data = getFormData(preparedData);

            this.requestProcessing = true;
            return request({ method, url, data })
                .then(() => {
                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    });

                    this.closeEditDialog();
                    this.requestProcessing = false;
                    this.loadItems();
                })
                .catch(this.errorHandler)
                .finally(() => {
                    this.requestProcessing = false;
                });
        },
        errorHandler(error) {
            const message = error.response && error.response.data && error.response.data.error;

            if (message) {
                this.$store.dispatch('alert/addMessage', {
                    message: `brand.${message}`,
                    time: 2000
                });
            }
        },
        closeEditDialog() {
            this.resetData();
            this.editDialog = false;
        },
        openRemoveDialog(id) {
            this.idToRemove = id;
            this.removeDialog = true;
        },
        closeRemoveDialog() {
          this.idToRemove = null;
          this.removeDialog = false;
        },
        async remove() {
            if (this.requestProcessing) {
                return;
            }

            this.requestProcessing = true;
            return request({
                method: 'delete',
                url: `/delivery/section/${this.idToRemove}`
            }).then(res => {
                if (res.status === 200) {
                    this.idToRemove = null;
                    this.removeDialog = false;
                    this.requestProcessing = false;
                    this.loadItems();
                }
            }).catch(error => this.errorHandler(error));
        },
        resetData() {
            this.section = sectionInitialState();

            if (this.userBrandId) {
                this.section.brandId = this.userBrandId;
                this.section.establishmentId = this.userEstablishmentId;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.active {
    color: green;
}

.inactive {
    color: red;
}
</style>
